import React from 'react';
import PropTypes from 'prop-types';
import {
  UpdateButton,
  DeleteButton,
  ViewButton,
  SaveButton,
} from '../Controls';

const DefaultActions = ({
  row,
  onEdit,
  onDelete,
  onView,
  onSave,
  children,
  viewPermissions,
  updatePermissions,
  deletePermissions,
  disableButtonDelete = false,
}) => (
    <>
      {onView && (
        <ViewButton
          onClick={() => onView(row)}
          requiredPermissions={viewPermissions}
        />
      )}
      {onEdit && (
        <UpdateButton
          onClick={() => onEdit(row)}
          requiredPermissions={updatePermissions}
        />
      )}
      {onDelete && (
        <DeleteButton
          onClick={() => onDelete(row)}
          requiredPermissions={deletePermissions}
          disabled={disableButtonDelete}
        />
      )}
      {onSave && (
        <SaveButton
          onClick={() => onSave(row)}
          requiredPermissions={updatePermissions}
        />
      )}
      {children}
    </>
  );

DefaultActions.propTypes = {
  // Data del registro a retornar
  row: PropTypes.oneOfType([PropTypes.object]),
  // Funcion para el UpdateButton
  onEdit: PropTypes.func,
  // Funcion para el DeleteButton
  onDelete: PropTypes.func,
  // Funcion para el ViewButton
  onView: PropTypes.func,
  // Funcion para el SaveButton
  onSave: PropTypes.func,
  // Componentes adicionales
  children: PropTypes.node,
  // Permisos para editar
  updatePermissions: PropTypes.oneOfType([PropTypes.array]),
  // Permisos para eliminar
  deletePermissions: PropTypes.oneOfType([PropTypes.array]),
  // Permisos para ver
  viewPermissions: PropTypes.oneOfType([PropTypes.array]),
};

export default DefaultActions;
